/**
 * Vruchtvlees © 2007-2018
 *
 * Hi, welcome!
 *
 * This is the main Javscript file.
 * One script to rule them all!
 * Let's go and godspeed you!
 */

import $ from "jquery";
import jQuery from "jquery";

/** ----------------------------------------
    Webpack Settings
 ---------------------------------------- */

let webpack = SETTINGS;

/** ----------------------------------------
    Environment
 ---------------------------------------- */

/**
 * This class will check the current
 * environment of the website and stores
 * an object with information about the
 * current environment.
 */

import { Environment } from './helpers/Environment.js';
import { Log } from './helpers/Log.js';

const host = new Environment({
    localhost: 'rialto-website',
    preview: '',
    webpack: webpack
});

const log = new Log(host);

if(!host.info.environment.live) {
    log.title('Environment');
    host.log();
}

/** ----------------------------------------
    Set Style Guide
 ---------------------------------------- */

/**
 * This section will set the VV Style Guide
 * as a default for at the index.html.
 *
 * You can mess around with the information 
 * it will be displayed within the page.
 */

import { Style } from './style/Style';

let info = {
    title: 'Vruchtvlees Digital Style Guide',
    intro: 'This style guide provides guidelines for the digital design as configured within the SASS stylesheets. It will automatically extend and change once you start working on the project. If certain elements or blocks should be left out these can be configured within the config.js file related to the style guide. It serves as a guide to quickly check what variables have been configured, what names they use and how the styling of a certain element has been affected within the stylesheet. Godspeed you!',
};

let config = {
    breakpoints: true,
    typo: true,
    letters: true,
    colors: true,
    headings: true,
    text: true,
    content: true,
    font: true,
    links: true,
    tooltip: true,
    forms: true,
    lists: true,
    tables: true,
    buttons: true,
    icons: true
};

const style = new Style(info, config, webpack.config.production && true);

if(!host.info.environment.live) {
    log.title('Style');
    style.log();
}

/** ----------------------------------------
    Navigation
 ---------------------------------------- */

import { StickyNavigation } from './module/StickyNavigation';
new StickyNavigation();

/** ----------------------------------------
    Toggle Mobile Menu
 ---------------------------------------- */

import { MobileMenu } from './module/MobileMenu';
new MobileMenu();

/** ----------------------------------------
    Responsive Images
 ---------------------------------------- */

import { ResponsiveImages } from './module/ResponsiveImages';

let responsive = new ResponsiveImages(style);

if(!host.info.environment.live) {
    log.title('Responsive');
    responsive.log();
}

/** ----------------------------------------
    Slick Slider
 ---------------------------------------- */

/**
 * The Slick Slider provides several
 * helpful configuration options to create
 * sliders within the page.
 *
 * @documentation   http://kenwheeler.github.io/slick/
 */

import { Slick } from 'slick-carousel';

let $gallery = $('.gallery__container--large');

$gallery.slick({
    autoplay: true,
    autoplaySpeed: 7500,
    pauseOnHover: false,
    centerMode: true,
    slidesToShow: 1,
    arrows: true,
    prevArrow: '<div class="slider__arrow slider__arrow--previous gallery__arrow gallery__arrow--previous"></div>',
    nextArrow: '<div class="slider__arrow slider__arrow--next gallery__arrow gallery__arrow--next"></div>',
    dots: false,
    speed: 750,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
    infinite: true,
    responsive: [
        {
            breakpoint: parseInt(style.data.breakpoints['tablet-small'], 10),
            settings: {
                arrows: false,
                centerMode: false,
                cssEase: 'ease',
            }
        }
    ]
});

/** ----------------------------------------
    Home Header
 ---------------------------------------- */

import { Home } from './module/Home';
new Home();

/** ----------------------------------------
    Video Header
 ---------------------------------------- */

import { Video } from './module/Video';
new Video('#js-video');

/** ----------------------------------------
    Notification
 ---------------------------------------- */

import { Notification } from './module/Notification';
new Notification();

/** ----------------------------------------
    Dropdown
 ---------------------------------------- */

import { Dropdown } from './module/Dropdown';

const dropdownElems = document.querySelectorAll('.dropdown__options');

for (let dropdownEl of dropdownElems) {
    new Dropdown({
        holder: dropdownEl,
        trigger: '.dropdown__selected',
        target: '.dropdown__holder',
        options: '.dropdown__form'
    }, style);
}

/** ----------------------------------------
    Filter
 ---------------------------------------- */

import { Filter } from './module/filter/Filter.js';

if (document.querySelector('#set-location')) {

    const location = document.querySelector('#set-location').getAttribute('data-building');
    const filter = {
        feeds: {
            items: '/feed/' + host.info.language + '/program/' + location + '/28',
            mapping: '/feed/' + host.info.language + '/program-filters/28'
        }
    };

    new Filter(filter, host);
}

/** ----------------------------------------
     Social Share
 ---------------------------------------- */

import SocialShare from './module/SocialShare';

const share = document.querySelectorAll('[data-module="social"]');

for (let item of share) {
    if(item) new SocialShare(item);
}

/** ----------------------------------------
    Newsletter
 ---------------------------------------- */

import { Mailchimp } from './module/Mailchimp';
new Mailchimp(host);

/** ----------------------------------------
    Toggle Footer
 ---------------------------------------- */

import { Footer } from './module/Footer';
new Footer();

/** ----------------------------------------
    Toggle Footer
 ---------------------------------------- */

import { Tickets } from './module/Tickets';
new Tickets(host);

/** ----------------------------------------
    News
 ---------------------------------------- */

import { News } from './module/News';
new News(host);

/** ----------------------------------------
    Preview Item
 ---------------------------------------- */

// import { Preview } from './module/Preview';
// // new Preview();

/** ----------------------------------------
    Narrow Casting
 ---------------------------------------- */

import { Screen } from './module/narrowcasting/Screen.js';

if ($("body").hasClass('narrowcasting')) {
    new Screen(host);
}


/** ----------------------------------------
    Locations filter
 ---------------------------------------- */
const locationBtn = $('#location-btn');
const locationSelected = $('.location__filter .dropdown__selected');
 $('#filter-locations').change(function() {
    locationBtn.addClass('is-active');
    locationBtn.attr('data-href', $(this).find('input:checked').val());
    locationSelected.find('p').text($(this).find('input:checked + label').text());
 });

 locationBtn.click(function(){
    window.location.href = locationBtn.attr('data-href');
 });

